<script lang="typescript">
 import LensDetail from './LensDetail.svelte';
 import { variantImages } from '../appData.js';
</script>

<style>
 .tint-img {
     @apply w-1/2 my-6;
 }
</style>

<LensDetail title="Tint & UV" images="{variantImages.tintUV}">
    <div>
	<h3>Green</h3>
	<ul>
	    <li>Enhances contrast in natural light</li>
	    <li>Excellent for sports like golf</li>
	</ul>
	<img
	    alt="illustration of coloured lens transition"
	    class="tint-img"
	    src="/img/tint-green-2.png"
	/>
    </div>
    <div>
	<h3>Brown</h3>
	<ul>
	    <li>Enhances contrast in natural light</li>
	    <li>Great in low light</li>
	</ul>
	<img
	    alt="illustration of coloured lens transition"
	    class="tint-img"
	    src="/img/tint-brown-2.png"
	/>
    </div>
    <div>
	<h3>Grey</h3>
	<ul>
	    <li>Protection in all weather</li>
	    <li>All-purpose tint which does not enhance contrast or distort colours</li>
	    <li>Offers good protection against glare</li>
	</ul>
	<img
	    alt="illustration of coloured lens transition"
	    class="tint-img"
	    src="/img/tint-grey-2.png"
	/>
    </div>
</LensDetail>
